<!--
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2019-01-15 17:21:41
 * @LastEditors: wjx
 * @LastEditTime: 2019-04-08 14:49:38
 -->
<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
      class="ruleForm"
      :disabled="ifDisable"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="ruleForm.title" disabled></el-input>
      </el-form-item>
      <el-form-item label="照片">
        <ul>
          <li v-for="(item,index) in  ruleForm.imgList" :key="item.id" class="sampleBox">
            <div style="margin-right:20px;">{{index+1}}.</div>
            <UploadImgOne :initUrl="item.imgUrl" @upload-done="coverPicDone" :No="index"></UploadImgOne>
            <el-input v-model="item.imgDescribe" style="margin-left:20px;width:50%"></el-input>
          </li>
        </ul>
        <el-button @click="pushImgList" v-show="ruleForm.imgList.length<10">添加</el-button>
        <el-button @click="delImgList" v-show="ruleForm.imgList.length>1">删除</el-button>
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          v-model="ruleForm.content"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="btLoading">保存</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { btLoading } from "@/Mixin/btLoading";
import { bingli } from "@/api/ajax";
import { courseType, whetherOrNot } from "@/assets/staticData";
import dicSelect from "@/components/Common/dicSelect.vue";
import ChannelMultiple from "@/components/Channel/Multiple.vue";
import UploadImgOne from "@/components/Common/UploadImgOne.vue";
export default {
  mixins: [btLoading],
  data () {
    return {
      ifDisable: false,
      whetherOrNot,
      courseType,
      defaultObj: null,

      prop: {
        label: "enterpriseName",
        code: "id"
      },
      initSummary: "",
      initRoleImg: "",
      initProgram: "",
      fuckShow: [{ label: "是", value: 1 }, { label: "否", value: 2 }],
      ruleForm: {
        id: this.$route.query.id,
        bingliCount: 2,
        enterpriseId: "",
        imgList: [{}],
        projectName: "",
        imgUrl: []
      },
      // 校验
      rules: {
        title: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    dicSelect,
    ChannelMultiple,
    UploadImgOne
  },
  methods: {
    pushImgList () {
      this.ruleForm.imgList.push({
        createDt: "",
        id: "",
        imgDescribe: "",
        projectId: "",
        weight: ""
      });
    },
    delImgList () {
      this.ruleForm.imgList.pop();
    },
    contentChange (v) {
      this.ruleForm.lecturerIntroduction = v;
    },
    resetForm (formName) {
      this.$router.go(-1);
    },
    saveFCategoryId (val) {
      this.ruleForm.enterpriseId = val.id;
      this.ruleForm.platformId = val.platformId;
    },
    coverPicDone (v, index) {
      console.log(v, index)
      this.ruleForm.imgList[index].imgUrl = v;
    },
    coverPicDone2 (v) {
      this.ruleForm.roleImg = v;
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 改变按钮状态
          this.SET_BTLOADING(true);
          // 混合对象 格式化数据
          let describeList = [];
          for (var item of this.ruleForm.imgList) {
            describeList.push(item.imgUrl);
          }
          this.ruleForm.imgUrl = describeList;
          bingli.addUpdateBingli(this.ruleForm).then(res => {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success"
            });
            this.resetForm();
          });
        } else {
          return false;
        }
      });
    }
  },
  watch: {},
  created () {
    if (this.$route.query.id) {
      bingli
        .loadProject2({
          id: this.$route.query.id
        })
        .then(res => {
          let resp = res.data.data;
          this.defaultObj = {
            enterpriseName: resp.enterpriseName,
            id: resp.enterpriseId
          };
          this.ruleForm = resp;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.longitude-div {
  display: flex;
}
.sampleBox {
  display: flex;
  align-items: center;
  img {
    width: 200px;
    height: 200px;
  }
}
</style>
